export enum Zone {
  Cart = 'cart',
  MagicRow = 'magicRow',
  StoreMenu = 'storeMenu',
  StoreMenuInline = 'storeMenuInline',
  StorePdp = 'storePDP',
}
